import { FC, useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { ROUTE } from "route";

import * as API from 'api';
import * as Meta from 'meta';
import * as Type from './type';
import { gaEvent } from "utils";

import { useAuth } from "hooks";
import { Header, Footer } from "components";

let name = "";

export const RecordPage: FC = () => {
  const auth = useAuth();
  const history = useHistory();
  const [qrRecord, setQrRecord] = useState<Type.IQrRecord[]>([]);

  const logout = () => {
    localStorage.removeItem("ishara");
    auth.setIsAuth(false);
    history.push(ROUTE.HOME);
  };

  useEffect(() => {
    if (!API.getToken()) return;
    fetch(API.ticket(true))
      .then((res) => res.json())
      .then((json) => {
        if(!json) return;
        const { user } = json;
        name = (
          user.name ||
          user.google_name ||
          user.fb_name ||
          user.email ||
          "");
        setQrRecord(json.tickets);
      });
  }, []);

  return (
    <div className="wrapper">
      {Meta.loadCSS(['record', 'notice'])}
      {Meta.loadJS('main-0625')}
      {Meta.ga("抽獎紀錄頁")}
      <Header />
      <div className="main">
        <div className="page_text mt">抽獎紀錄</div>
        <section className="record inner">
          <div className="record_box">
            <div className="record_name mp"><i className="fas fa-user-circle" /><span>{name}</span></div>
            {/* <div className="record_btbox">
              <li><Link to={ROUTE.SCAN}>立即掃描</Link></li>
              <span>|</span>
              <li><Link to={ROUTE.HOME} onClick={logout}>登出</Link></li>
            </div> */}
            {!!qrRecord.length &&
            <>
              <table className="record_table_top">
                <thead>
                  <tr>
                    <th className="record_l">QRcode掃描時間</th>
                    <th className="record_r">掃描結果</th>
                  </tr>
                </thead>
              </table>
              <div className="table_over">
                <table className="record_table_in">
                  <tbody>
                    {qrRecord.map((item, index) => (
                      <tr key={index}>
                        <td className="record_c">{item.time}</td>
                        <td>{item.is_winner ? item.prize_alias : "差一點點，爽勁不夠"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
            }
          </div>
          <div className="record_btbox">
            <Link to={ROUTE.SCAN} onClick={gaEvent.bind(null, '抽獎紀錄', '立即掃描')}><li>立即掃描</li></Link>
            <Link to={ROUTE.HOME} onClick={() => {
              gaEvent('抽獎紀錄', '登出');
              logout();
            }}><li>登出</li></Link>
          </div>
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
